import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=f47d2a64&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=f47d2a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47d2a64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f47d2a64')) {
      api.createRecord('f47d2a64', component.options)
    } else {
      api.reload('f47d2a64', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=f47d2a64&scoped=true&", function () {
      api.rerender('f47d2a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PtMITDlJ8ZSM/JS/comp/CookieBox.vue"
export default component.exports